import { useEffect } from 'react';
export function useBodyClass(bodyClass) {
    useEffect(() => {
        document.body.classList.add(bodyClass);
        return () => {
            document.body.classList.remove(bodyClass);
        };
    }, [bodyClass]);
}
